// src/data/musicVideos.js
export const musicVideos = [
  {
    id: "d0X7gMAfso4",
    title: "New Video 1", // You can update these titles with actual song names
  },
  {
    id: "eGpZqV_VxH0",
    title: "New Video 2",
  },
  {
    id: "nVCZwtnzp7I",
    title: "New Video 3",
  },
  {
    id: "iCvb6zBNJBU",
    title: "New Video 4",
  },
  {
    id: "ZE-hN4MvBN8",
    title: "New Video 5",
  },
];
